const { flatten, filter, find } = require('lodash');

const KEY_CODES = {
    LEFT: 37,
    RIGHT: 39,
};

class StringFilterController {
    constructor($state, moveFocus) {
        this.$state = $state;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        // TODO: account for other screen sizes
        this.howManyFiltersToShowWhenCollapsed = this.isLargeFormat ? 9 : 8;
        this.howManyFiltersToShow = this.howManyFiltersToShowWhenCollapsed;
    }

    $onChanges(changes) {
        if (changes.filter && this.filter != null) {
            this.filterName = this.filter.Name;
            this.filterGroups = [this.getAllFilters(this.filter.ResultsGrouped), ...this.filter.ResultsGrouped];
            this.selectableFilterGroups = this.filterGroups.filter(fg => this.isSelectable(fg));

            const currentlySelectedFilterGroup = find(this.filterGroups, fg => fg.Alphabet === this.selectedAlphabet);

            if (!currentlySelectedFilterGroup || !this.isSelectable(currentlySelectedFilterGroup)) {
                this.selectFilterGroup(find(this.filterGroups, fg => this.isSelectable(fg)));
            }
        }
    }

    getAllFilters(filters) {
        return { Alphabet: 'All', Filters: flatten(this.filterUnavailbleStringFilters(filters).map(f => f.Filters)) };
    }

    filterUnavailbleStringFilters(filters) {
        return filters && filters.length > 0 ? filter(filters, f => f.Filters && f.Filters.length > 0) : [];
    }

    toggleSelection(filterName, filterTerm) {
        const selectedFilter = find(find(this.filterGroups, fg => fg.Alphabet === 'All').Filters, ft => ft.Name === filterTerm);
        selectedFilter.Applied = !selectedFilter.Applied;

        this.onToggleFilter({ filterName, filterTerm });
    }

    onAlphabetKeydown($event, filterGroupIndex) {
        if ($event.which === KEY_CODES.LEFT) {
            for (let i = Math.max(filterGroupIndex - 1, 0); i >= 0; i--) {
                if (this.trySelectFilterGroup(this.filterGroups[i])) break;
            }
        } else if ($event.which === KEY_CODES.RIGHT) {
            for (let i = Math.min(filterGroupIndex + 1, this.filterGroups.length); i < this.filterGroups.length; i++) {
                if (this.trySelectFilterGroup(this.filterGroups[i])) break;
            }
        }
    }

    trySelectFilterGroup(filterGroup) {
        if (this.isSelectable(filterGroup)) {
            this.selectFilterGroup(filterGroup);

            return true;
        }

        return false;
    }

    selectFilterGroup(filterGroup) {
        this.howManyFiltersToShow = this.howManyFiltersToShowWhenCollapsed;
        this.selectedAlphabet = filterGroup.Alphabet;

        this.moveFocus(`#${filterGroup.Alphabet}Tab`, true);
    }

    isSelected(filterGroup) {
        return filterGroup.Alphabet === this.selectedAlphabet;
    }

    isSelectable(filterGroup) {
        return filterGroup && filterGroup.Filters && filterGroup.Filters.length > 0;
    }

    toggleExpanded() {
        this.howManyFiltersToShow = this.isExpanded
            ? this.howManyFiltersToShowWhenCollapsed
            : null;
    }

    isExpandable(filters) {
        return filters && filters.length > this.howManyFiltersToShowWhenCollapsed;
    }

    get isExpanded() {
        return this.howManyFiltersToShow !== this.howManyFiltersToShowWhenCollapsed;
    }

    toggleContent() {
        this.openContent = !this.openContent;
    }
}

StringFilterController.$inject = ['$state', 'MoveFocus'];

const stringFilterComponentDefinition = {
    bindings: {
        filter: '<',
        onToggleFilter: '&',
        isLargeFormat: '<',
    },
    controller: StringFilterController,
    template: require('./string-filter.component.html').trim(),
};

module.exports = {
    StringFilterController,
    stringFilterComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/filter/string-filter.component.js